module.exports = {
    fetchMyInvestments: () =>{}
};
